import React, { useState } from 'react'
import { IMFAModalProps, ModalType } from './MFAEnableModal'
import { Form, Modal, Typography } from 'antd'
import MaskedInput from 'antd-mask-input'
import { disableMFA } from '../../../api/mfa'

export const MfaDisableModal = (props: IMFAModalProps): React.ReactElement => {
	const [loading, setIsLoading] = useState(false)
	const [form] = Form.useForm<{ code: string }>()

	const [answer, setAnswer] = useState({
		success: false,
		message: ''
	})

	async function disableMFAHandler() {
		const res = await disableMFA(form.getFieldsValue().code)

		setIsLoading(false)

		if (res.success) {
			setAnswer({ message: '', success: false })
			setIsLoading(false)
			form.resetFields()

			props.close(ModalType.DISABLE, true)
		} else {
			setAnswer(res)
		}
	}

	return (
		<Modal
			title="Отключение 2FA"
			visible={props.visible}
			onCancel={() => {
				if (!loading) {
					props.close(ModalType.DISABLE, false)
				}
			}}
			onOk={() => {
			    setIsLoading(true)
				void disableMFAHandler()
			}}
			okButtonProps={{
				loading,
				type: 'ghost'
			}}
			cancelButtonProps={{
				disabled: loading,
				type: 'primary'
			}}

			okText="Да"
			cancelText="Нет"
			closable={!loading}
		>
			<Typography.Title level={5}>
                Вы точно уверены, что хотите отключить двухфакторную авторизацию?
			</Typography.Title>

			<Typography>
                Если вы отключите двухфакторную авторизацию, то
                вы будете уязвимы к взломам. Мы настоятельно <b>НЕ</b> {' '}
                рекомендуем вам нажимать на "Да".
			</Typography>

			{answer ? (
				<Typography style={{ color: 'red', margin: '2% 0' }}>
					{answer.message}
				</Typography>
			) : <></>}

			<Form form={form} layout="vertical">
				<Form.Item label="Код двухфакторной авторизации" name="code">
					<MaskedInput mask="111 111"/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
